import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
   * When a product is added to the cart, instead of opening the drawer,
   * redirect the user directly to the cart page.
   */
  #handleCartAdd = () => {
    window.location.href = '/cart';
  };

  /**
   * Override the drawer open function to redirect instead of showing the drawer.
   */
  open() {
    window.location.href = '/cart';
  }

  /**
   * Close function is irrelevant now but kept for safety.
   */
  close() {
    this.closeDialog?.();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
